module.exports = __webpack_public_path__ + "img/step_1.55f32816.svg";